import _range from 'lodash/range';
import _sum from 'lodash/sum';

/**
 * 圆点的类型
 * value 关联在 css 中
 */
const enum IndicatorDotSize {
  Big = 'big',
  Middle = 'middle',
  Small = 'small',
  Gone = 'gone',
}

/**
 * 计算要展示的圆点的类别
 */
export default function useDotsType(count: number, current: number): IndicatorDotSize[] {
  const dotsTypeList = _range(count).map((_) => IndicatorDotSize.Gone);

  // 计算所有需要展示的点位
  // 按照从中心到两边的顺序排列
  const positions = _range(5)
    .flatMap((shift) => {
      if (shift === 0) {
        return current;
      }
      return [current + shift, current - shift].filter((i) => i > -1 && i < count) as number[];
    })
    .slice(0, 5);

  // 标记大点
  positions.slice(0, 3).forEach((pos) => (dotsTypeList[pos] = IndicatorDotSize.Big));

  // 计算大点中心位置
  const center = _sum(positions.slice(0, 3)) / 3;

  // 标记中点和小点
  positions.slice(3, 5).forEach((pos) => {
    dotsTypeList[pos] = Math.abs(pos - center) < 3 ? IndicatorDotSize.Middle : IndicatorDotSize.Small;
  });

  return dotsTypeList;
}
